import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import style from "./style.less";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Icon from "../Icon/Icon";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {FormListInputProps} from "./FormDialog";


export const FormListInput: React.FunctionComponent<{
  props: FormListInputProps
  defaultValue: string | string[]
  onChange: (fieldName: string, value: any) => void
}> = ({ props, defaultValue, onChange }) => {
  if (props.multiple) {
    // Figure out the selected options based on their values
    const selectedOptions = Array.isArray(defaultValue)
      ? props.selections.filter((option) => defaultValue.includes(option.value))
      : []

    return (
      <Autocomplete
        classes={{ paper: style.autocompleteFieldMenu }}
        renderInput={(params) => (
          <TextField
            {...params}
            hiddenLabel
            key="text-field-input"
            placeholder={props.placeHolderText}
            className={props.className}
            InputProps={{
              ...params.InputProps,
              ...(props.inputProps ? { style: props.inputProps.style } : {})
            }}
          />
        )}
        multiple
        disableClearable={true}
        defaultValue={selectedOptions}
        onChange={(event, newValue) => {
          onChange(props.name, newValue.map((option: any) => option.value))
        }}
        disabled={props.disabled === true}
        options={props.selections}
        getOptionLabel={(option: any) => option.name}
        renderOption={(props, option: any) => (
          <div key={`option-${option.value}`}>
            {typeof option.item === 'function'
              ? option.item(props)
              : option.item}
          </div>
        )}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            // eslint-disable-next-line react/jsx-key
            <Chip
              {...getTagProps({ index })}
              label={option.name}
            />
          ))
        }
        popupIcon={<Icon name={'ExpandMore'} />}
      />
    )
  }

  return props.editable ? (
    <Autocomplete
      classes={{ paper: style.autocompleteFieldMenu }}
      renderInput={(params) => (
        <TextField
          {...params}
          hiddenLabel
          key="text-field-input"
          placeholder={props.placeHolderText}
          className={props.className}
          InputProps={{
            ...params.InputProps,
            ...(props.inputProps ? { style: props.inputProps.style } : {})
          }}
        />
      )}
      defaultValue={defaultValue || null}
      onChange={(event) => {
        onChange(props.name, (event.target as HTMLElement).textContent)
      }}
      disabled={props.disabled === true}
      options={props.selections as any}
      getOptionLabel={(option: any) => option.value}
      renderOption={(props, option: any) => (
        <div key={`option-${option.value}`}>
          {typeof option.item === 'function'
            ? option.item(props)
            : option.item}
        </div>
      )}
      popupIcon={<Icon name={'ExpandMore'} />}
    />
  ) : (
    <Select
      displayEmpty
      className={style.inputField}
      defaultValue={defaultValue}
      onChange={(event) => onChange(props.name, event.target.value)}
      disabled={props.disabled === true}
      MenuProps={{ classes: { paper: style.inputFieldMenu } }}
      IconComponent={(_props) => {
        const opened = _props.className.toString().includes('iconOpen')
        return (
          <Icon
            className={style.iconSelect}
            name={opened ? 'ExpandLess' : 'ExpandMore'}
          />
        )
      }}
      renderValue={(value) => {
        return !value
          ? props.placeHolderText
          : props.selections.map(
            (selection) => {
              if (selection.value === value) {
                if (typeof selection.item === 'function') {
                  return selection.item({})
                }
                return selection.item
              }
              return null
            }
          ).find((item) => item !== null)
      }}
    >
      {props.selections.map((selection, index) => (
        <MenuItem key={index} value={selection.value}>
          {typeof selection.item === 'function'
            ? selection.item({})
            : selection.item}
        </MenuItem>
      ))}
    </Select>
  )
}
